<template>
  <div class="content-wrappper resources-map">
    <div class="row tool-container mr-0 ml-0">
      <div class="col-md-12 box-body">
        <div class="row">
          <div class="col-md-12">
            <div class="header_box header-container">
              <h4 class="heading">Explorer</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9 description-column pr-24 pl-24">
            <div class="header_box description-container pl-0 pr-0">
              <p>
                This interactive tool helps explore what RAMS has to offer for global market access
                and ongoing regulatory compliance needs. Emergo by UL’s digital application
                platform, RAMS, brings together over two decades of Emergo’s regulatory expertise
                that spans across 60+ countries coupled with a rich suite of easy to use,
                collaborative technology capabilities.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="pl-15 pr-15">
            <div class="header_box products-container">
              <h4 class="heading">Products Overview</h4>
            </div>
          </div>
        </div>
        <div class="dashboard-dropdown d-flex flex-between pl-15 pb-24">
          <div class="dropdown-container d-flex flex-between">
            <div
              class="mr-30 country-section"
              :class="{
                'opacity-05': selectedResource && !country && !listView,
                '': listView,
                '': !listView
              }"
            >
              <div class="country-dropdown-container d-flex align-items-center">
                <div class="country-label-wrapper" :class="{ 'country-label-mapvw': !listView }">
                  <div class="label-dropdown">
                    <span>Country</span>
                  </div>
                </div>
                <div class="country-dropdown" v-if="!listView">
                  <multiselect
                    :allow-empty="false"
                    :show-labels="false"
                    :searchable="true"
                    open-direction="bottom"
                    :disabled="
                      selectedResource.value != 'Select All' && !country && !listView ? true : false
                    "
                    placeholder="Select Country"
                    class="multiselect-single-dropdown resourcesMapView"
                    :class="
                      selectedResource.value != 'Select All' && !country && !listView
                        ? 'disable-drop-down'
                        : ''
                    "
                    v-model="country"
                    :options="countryList"
                    @input="countrySelected"
                  >
                    <span slot="option" slot-scope="props">
                      <span
                        class="option-desc"
                        :class="
                          country == 'Select All' || country == props.option
                            ? 'font-bold'
                            : 'font-wt-400'
                        "
                        >{{ props.option }}</span
                      >
                    </span>
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
                <div class="country-dropdown" v-else>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :searchable="true"
                    :options="countryList"
                    v-model="country"
                    @input="countrySelected"
                    placeholder="Select Country"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div
              class="resource-section"
              :class="{ 'opacity-05': !selectedResource && country }"
              v-if="!listView"
            >
              <div class="resource-dropdown-container d-flex align-items-center">
                <div class="resource-label-wrapper">
                  <div class="label-dropdown">
                    <span>Resource</span>
                  </div>
                </div>
                <div class="resource-dropdown">
                  <multiselect
                    :show-labels="false"
                    :allow-empty="false"
                    open-direction="bottom"
                    :searchable="false"
                    :disabled="!selectedResource.value && country ? true : false"
                    placeholder="Select Resource"
                    v-model="selectedResource"
                    class="multiselect-single-dropdown resourcesMapView resources"
                    :class="!selectedResource.value && country ? 'disable-drop-down' : ''"
                    :options="options"
                    group-label="label"
                    :group-select="false"
                    group-values="options"
                    @input="getListOfCountries"
                    track-by="value"
                    label="label"
                  >
                    <span slot="option" slot-scope="props">
                      <span
                        class="group-desc"
                        v-if="props.option.$groupLabel && props.option.$groupLabel.length"
                        >{{ props.option.$groupLabel }}</span
                      >
                      <span
                        v-else
                        class="option-desc"
                        :class="
                          selectedResource.value == 'Select All' ||
                          selectedResource.value == props.option.value
                            ? 'font-bold'
                            : 'font-wt-400'
                        "
                        >{{ props.option.label }}</span
                      >
                    </span>
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="clear-button-wrapper">
            <button
              class="btn btn-block btn-clr emergo-white-button"
              :disabled="disableClear"
              @click="clearSelection"
            >
              Clear
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-12 col-lg-12 pl-24 pr-24">
            <div class="list-view-widget p-15">
              <div class="row pt-5">
                <ul class="nav nav-tabs pl-24 pr-24">
                  <li
                    @click="toggleView(listView)"
                    class="nav-item"
                    :class="{ 'selected-view active': !listView, 'unselected-view': listView }"
                  >
                    Map View
                  </li>

                  <li
                    @click="toggleView(!listView)"
                    class="nav-item"
                    :class="{ 'selected-view active': listView, 'unselected-view': !listView }"
                  >
                    List View
                  </li>
                </ul>
              </div>
              <country-resources-list
                v-if="listView"
                :dataList="listViewData"
                :country="country"
                :EUCountries="EUCountries"
              ></country-resources-list>
              <map-view
                :resources="resourcesDropDownList"
                :services="servicesDropDownList"
                :countriesList="countriesList"
                :filteredCountries="filteredCountries"
                :validateFilter="validateFilter"
                :resourceData="resourceData"
                :serviceData="serviceData"
                :countrySelection="countrySelection"
                :EUCountries="EUCountries"
                @loaderEvent="mapLoaderStatus"
                v-else
              ></map-view>
            </div>
          </div>
        </div>
        <div class="row" v-if="!listView">
          <div class="col-md-12" v-if="selectedResource && selectedResource.value !== 'Select All'">
            <div class="header_box">
              <div class="list-header">Available in:</div>
              <div v-for="(country, index) in displayCountryList" :key="index">{{ index }}</div>
              <div
                class="pointer cust-link cursor-pointer"
                v-if="displayView && Object.keys(filteredCountries).length > 5"
                @click="displayView = false"
              >
                View more
              </div>
              <div
                class="pointer cust-link cursor-pointer"
                v-if="!displayView && Object.keys(filteredCountries).length > 5"
                @click="displayView = true"
              >
                View less
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import _ from 'lodash';
import CountryResourcesList from './CountryResourcesList.vue';
import MapView from './MapView.vue';
import Loader from '../UIComponents/Loader.vue';
import {
  getResourcesList,
  getCountriesByResourceId,
  getCountriesByServiceId,
  getResoucesCountries,
  getEUCountriesList
} from '../../apis/resourcesDashboard';
import { getServiceDesc } from '../../apis/marketPlace';

export default {
  data() {
    return {
      listView: false,
      listViewData: {},
      country: 'Select All',
      countryList: ['Select All'],
      options: [
        {
          label: '',
          options: [
            {
              value: 'Select All',
              label: 'Select All'
            }
          ]
        }
      ],
      selectedResource: {
        label: 'Select All',
        value: 'Select All'
      },
      resourcesDropDownList: '',
      servicesDropDownList: '',
      loaderStatus: false,
      filteredCountries: {},
      countriesList: {},
      validateFilter: false,
      serviceData: [],
      resourceData: [],
      displayView: true,
      countrySelection: false,
      EUCountries: [],
      elDropdownOpend: '',
      dropdownSelected: false
    };
  },
  components: {
    CountryResourcesList,
    MapView,
    Loader
  },
  computed: {
    displayCountryList() {
      let list = this.filteredCountries;
      if (Object.keys(this.filteredCountries).length) {
        if (this.displayView) {
          list = {};
          list = Object.fromEntries(Object.entries(this.filteredCountries).slice(0, 5));
        }
      }
      return list;
    },
    disableClear() {
      let dis = true;
      if (this.listView && this.country) {
        dis = false;
      }
      if (!this.listView) {
        if (this.country !== 'Select All' || this.selectedResource.value !== 'Select All') {
          dis = false;
        }
      }
      return dis;
    }
  },
  async created() {
    const isQueryParams = this.$route.query.country;
    if (isQueryParams) {
      this.toggleView(true);
    }
    await this.getResourcesList();
    await this.getServices();
    this.formatDropdownList();
    await this.getEUCountriesList();
    await this.getResoucesCountries(true);
    if (isQueryParams) {
      this.country = isQueryParams;
      this.countrySelected();
    }
  },
  methods: {
    mapLoaderStatus(status) {
      this.loaderStatus = status;
    },
    countryLabel(country) {
      let countryName = country;
      if (window.innerWidth < 768 && country && country.length > 40) {
        const i = country.indexOf(' ', 30);
        countryName = `${country.substring(0, i)}<br>${country.substring(i + 1)}`;
      }
      return countryName;
    },
    clearSelection() {
      if (this.listView) {
        this.country = '';
        this.resetListView();
      } else {
        this.countrySelection = false;
        this.country = 'Select All';
        this.selectedResource = {
          label: 'Select All',
          value: 'Select All'
        };
        this.filteredCountries = this.countriesList;
      }
    },
    async getResoucesCountries(generateList = false) {
      this.loaderStatus = true;
      const countryList = await getResoucesCountries();
      this.loaderStatus = false;
      this.countriesList = this.formatCountriesList(countryList, generateList);
      this.filteredCountries = this.countriesList;
    },
    formatCountriesList(countryList, generateList = false) {
      const dataArray = {};
      const userData = JSON.parse(localStorage.getItem('userData'));
      const validUser = !(
        userData.account_type_id === 2 ||
        userData.account_type_id === 4 ||
        userData.role_id === 5 ||
        userData.role_id === 7
      );
      for (let i = 0; i < countryList.length; i += 1) {
        dataArray[countryList[i].country_name] = countryList[i];
        // Remove Representation resources for non rep account
        if (validUser) {
          dataArray[countryList[i].country_name].resources = _.filter(
            countryList[i].resources,
            (value) => value !== 5
          );
        }
        // Remove eQMS and complaincewire
        dataArray[countryList[i].country_name].services = _.filter(
          countryList[i].services,
          (value) => value !== 5 && value !== 8
        );
        if (generateList) {
          this.countryList.push(countryList[i].country_name);
        }
      }
      return dataArray;
    },
    formatDropdownList() {
      const resourceList = [];
      const resourceData = [];
      const serviceList = [];
      const serviceData = [];
      _.forEach(this.resourcesDropDownList, (value) => {
        resourceList.push({
          value: `res_${value.id}`,
          label: value.name
        });
        resourceData[value.id] = value;
      });
      this.options.push({
        label: `Free resources (${resourceList.length})`,
        options: resourceList
      });
      this.resourceData = resourceData;
      _.forEach(this.servicesDropDownList, (value) => {
        serviceList.push({
          value: `ser_${value.id}`,
          label: value.name
        });
        serviceData[value.id] = value;
      });
      this.options.push({
        label: `Premium Services (${serviceList.length})`,
        options: serviceList
      });
      this.serviceData = serviceData;
    },
    validateRepAccount(resourceData) {
      let validData = resourceData;
      const userData = JSON.parse(localStorage.getItem('userData'));
      // Remove Representation resources for non rep account
      if (
        !(
          userData.account_type_id === 2 ||
          userData.account_type_id === 2 ||
          userData.role_id === 5 ||
          userData.role_id === 7
        )
      ) {
        validData = _.filter(resourceData, (value) => value.id !== 5);
      }
      validData = _.orderBy(validData, 'sequence', 'asc');
      return validData;
    },
    async getEUCountriesList() {
      this.loaderStatus = true;
      const EUCountries = await getEUCountriesList();
      _.forEach(EUCountries, (value) => {
        this.EUCountries.push(value.country_name);
      });
      this.loaderStatus = false;
    },
    async getResourcesList() {
      this.loaderStatus = true;
      const resourceData = await getResourcesList();
      this.resourcesDropDownList = this.validateRepAccount(resourceData);
      this.loaderStatus = false;
    },
    async getServices() {
      this.loaderStatus = true;
      const serviceData = await getServiceDesc();
      // Remove eQMS and complaincewire
      let validData = _.filter(
        serviceData,
        (value) => value.id !== 5 && value.id !== 8 && value.id !== 9 && value.id !== 10
      );
      validData = _.orderBy(validData, 'sequence', 'asc');
      this.servicesDropDownList = validData;
      this.loaderStatus = false;
    },
    async getListOfCountries() {
      this.dropdownSelected = true;
      let responseData = '';
      this.validateFilter = true;
      this.displayView = true;
      this.country = '';
      this.loaderStatus = true;
      if (this.selectedResource.value === 'Select All') {
        this.country = 'Select All';
        responseData = await getResoucesCountries();
        this.validateFilter = false;
      } else {
        const validateResource = this.selectedResource.value.split('_');
        if (validateResource[0] === 'res') {
          responseData = await getCountriesByResourceId(validateResource[1]);
        }
        if (validateResource[0] === 'ser') {
          responseData = await getCountriesByServiceId(validateResource[1]);
        }
      }
      this.loaderStatus = false;
      this.filteredCountries = this.formatCountriesList(responseData);
    },
    toggleView(valid) {
      this.filteredCountries = {};
      if (valid) {
        this.listView = !this.listView;
        this.countryListToggle();
      }
    },
    async countryListToggle() {
      this.countrySelection = false;
      this.country = '';
      if (!this.listView) {
        this.selectedResource = {
          label: 'Select All',
          value: 'Select All'
        };
        await this.getListOfCountries();
        if (this.countryList[0] !== 'Select All') {
          this.countryList.unshift('Select All');
        }
        this.country = 'Select All';
      } else if (this.listView) {
        this.resetListView();
        if (this.countryList[0] === 'Select All') {
          this.countryList.shift();
        }
      }
    },
    /* countrySelected()
     * to fire event when country is selected.
     */
    async countrySelected() {
      this.dropdownSelected = true;
      if (this.listView) {
        this.countrySelectedList();
      } else {
        this.countrySelectedMap();
      }
    },
    countrySelectedList() {
      const countryData = this.countriesList[this.country];
      const resources = [];
      const services = [];
      for (let i = 0; i < countryData.resources.length; i += 1) {
        resources.push(this.resourceData[countryData.resources[i]]);
      }
      for (let i = 0; i < countryData.services.length; i += 1) {
        services.push(this.serviceData[countryData.services[i]]);
      }
      this.$set(this.listViewData, 'resources', resources);
      this.$set(this.listViewData, 'services', services);
    },
    resetListView() {
      this.$set(this.listViewData, 'resources', this.resourcesDropDownList);
      this.$set(this.listViewData, 'services', this.servicesDropDownList);
    },
    countrySelectedMap() {
      this.selectedResource = {
        label: '',
        value: ''
      };
      this.validateFilter = false;
      if (this.country === 'Select All') {
        this.clearSelection();
      } else {
        this.countrySelection = true;
        const mapValue = [];
        mapValue[this.country] = this.countriesList[this.country];
        this.filteredCountries = mapValue;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.resources-map {
  .tool-container {
    .box-body {
      margin-bottom: 8%;

      .header_box {
        padding: 9px 9px 16px 9px;
        font-weight: $font-weight-small;
        font-size: $font-16;
        line-height: 19px;
        color: $black;
        .heading {
          font-family: $font-family-roboto;
          font-style: normal;
          font-weight: $font-weight-normal;
          font-size: $font-24;
          color: $primary;
        }
        &.header-container {
          padding-bottom: 0px;
          .heading {
            line-height: 28px;
            margin-bottom: 5px;
          }
        }
        &.description-container {
          border-bottom: 0.6px solid $gray74;
          padding-bottom: 21px;
          padding-left: 0px;
          padding-right: 0px;
          p {
            min-height: 57px;
            max-width: 1133px;
          }
        }

        &.products-container {
          padding-bottom: 20px;
          .heading {
            font-weight: $font-weight-400;
            font-size: $font-22;
            line-height: 26px;
            color: $dark-black-alpha;
          }
        }
        .list-header {
          padding: 10px 0px 7px 0px;
          font-family: $font-family-roboto;
          font-style: normal;
          font-weight: $font-weight-bold;
          font-size: 17px;
          line-height: 21px;
          color: $primary;
        }
      }
      .description-column {
        width: 100%;
      }
      .dashboard-dropdown {
        .dropdown-container {
          width: 750px;
          .country-section {
            width: 50%;
          }
          .country-dropdown {
            width: 100%;
            max-width: 297px;
          }
          .resource-section {
            width: 50%;
            .resource-dropdown {
              width: 297px;
            }
          }
          .resource-label-wrapper,
          .country-label-wrapper {
            width: fit-content;
            .label-dropdown {
              font-family: $font-family-roboto;
              font-style: normal;
              font-weight: $font-weight-400;
              font-size: $font-14;
              line-height: 16px;
              color: $dark-black-alpha;
              width: fit-content;
              margin-right: 8px;
              position: relative;
            }
          }
          .multiselect-single-dropdown {
            &.multiselect--disabled {
              ::v-deep {
                .multiselect__tags {
                  background-color: $gray95;
                  .multiselect__single {
                    background-color: inherit;
                  }
                }
              }
            }
          }
          .resource-dropdown-container {
            margin-right: 30px;
          }
        }
        .clear-button-wrapper {
          width: 131px;
          .btn:disabled {
            opacity: unset;
            background-color: $gray95;
            color: rgba(11, 60, 97, 0.6);
          }
        }
      }
      .list-view-widget {
        -webkit-box-shadow: $tertiary-box-shadow;
        box-shadow: $tertiary-box-shadow;
        border-radius: $radius10;
        background: $deep-white;
        .nav-item {
          padding-bottom: 16px;
          padding-top: 3px;
          font-family: $font-family-roboto;
          font-style: normal;
          font-size: $font-16;
          line-height: 19px;
          color: $dark-black-alpha;
          &.selected-view {
            font-weight: 700;
          }
          &.unselected-view {
            font-weight: $font-weight-400;
          }
        }
      }

      .cust-link {
        margin-top: 5px;
        color: $messenger-blue;
        font-size: $font-14;
      }
      .opacity-05 {
        // opacity: 0.5;
        ::v-deep .multiselect-single-d.multiselect__tags {
          background-color: $gray95;
        }
      }
    }
  }
  .multiselect-single-dropdown.resourcesMapView {
    ::v-deep {
      .multiselect__input {
        padding-top: 1px !important;
      }

      .multiselect-single {
        padding-top: 1px;
        padding-left: 4px;
      }

      .multiselect__content-wrapper {
        border: none;
      }
      .multiselect__option--selected:before {
        content: '';
      }

      .multiselect__option--selected {
        background: none;
      }
      .multiselect__option.multiselect__option--group::before {
        content: '';
      }
      .multiselect__option--group.multiselect__option--disabled {
        background: $white !important;
        font-family: $font-family-roboto;
        font-style: normal;
        font-weight: $font-weight-medium;
        font-size: $font-16;
        line-height: 19px;
        color: $primary !important;
        border-bottom: 1px solid #d3d6d9;
        border-top: 1px solid #d3d6d9;
        width: 90%;
        left: 15px;
        padding-left: 5px;
        .group-desc {
          margin-left: -3px;
        }
      }
    }
    .font-wt-400 {
      font-weight: $font-weight-400;
    }

    .font-bold {
      font-weight: $font-weight-bold;
    }
    .option-desc.font-bold::after {
      content: url('/static/images/icons/check.svg');
      position: absolute;
      right: 15px;
      width: 18px;
      height: 18px;
    }
    &.resources {
      ::v-deep {
        li:first-of-type {
          display: none;
        }
      }
    }
  }
}
.form-group {
  &.pl-2 {
    padding-left: 2px;
  }
}
@media (max-width: 600px) {
  .xs-pl-0 {
    padding-left: 0px;
  }
}
@media screen and (min-width: 1024px) {
  .pl-md-0 {
    padding-left: 0px;
  }
}

@media screen and (min-width: 768px) {
  .btn-clr {
    max-width: 120px;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .country-label-mapvw {
    padding-left: 0px;
    text-align: left;
  }
}
@media screen and (min-width: 1300px) {
  .resources-map {
    .tool-container {
      .box-body {
        .dashboard-dropdown {
          .dropdown-container {
            .resource-label-wrapper {
              // width: 22%;
            }
            .country-label-wrapper {
              // width: 20%;
            }
          }
          .clear-button-wrapper {
            padding-left: 0px;
          }
        }
      }
    }
  }
}

@media (max-width: 770px) {
  .resources-map {
    .tool-container {
      .box-body {
        .header_box {
          &.description-container {
            padding-bottom: 15px;
          }
        }
        .dashboard-dropdown {
          flex-direction: column;
          .dropdown-container {
            flex-direction: column;
            width: 100%;
            .country-section,
            .resource-section {
              width: 95.5%;
            }
            .country-section {
              margin-right: 0;
            }

            .country-dropdown,
            .resource-dropdown {
              width: 100% !important;
              max-width: unset;
            }
            .resource-label-wrapper,
            .country-label-wrapper {
              .label-dropdown {
                bottom: 8px;
              }
            }
            .country-dropdown-container,
            .resource-dropdown-container {
              flex-direction: column;
              align-items: flex-start;
              margin-bottom: 28px;
            }
            .resource-dropdown-container {
              margin-top: 32px;
              margin-bottom: 28px;
              margin-right: 0;
            }
          }
          .clear-button-wrapper {
            align-self: flex-end;
            padding-right: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 770px) and (min-width: 550px) {
  .resources-map {
    .tool-container {
      .box-body {
        .dashboard-dropdown {
          .dropdown-container {
            .country-section,
            .resource-section {
              width: 97.5%;
            }
          }
        }
      }
    }
  }
}
</style>
